import { ShieldCheck, Activity, Bot, Database, Workflow, LineChart } from "lucide-react";

const ICONS = { ShieldCheck, Activity, Bot, Database, Workflow, LineChart };

const ITEMS = [
  { icon: "ShieldCheck", title: "Enterprise Security", desc: "Bank-grade security and compliance controls" },
  { icon: "Activity", title: "Real-Time Intelligence", desc: "Live insights across your business and portfolio" },
  { icon: "Bot", title: "AI Automation", desc: "Intelligent automation across every workflow" },
  { icon: "Database", title: "Data Unification", desc: "One source of truth across all systems" },
  { icon: "Workflow", title: "Workflow Intelligence", desc: "Optimize processes using AI-driven intelligence" },
  { icon: "LineChart", title: "Predictive Analytics", desc: "Forecast outcomes and accelerate decisions" },
];

/**
 * Verifiable capability indicators (no fabricated metrics).
 */
export default function CapabilityStrip() {
  return (
    <section className="relative pb-14 lg:pb-16" data-testid="capability-strip">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="rounded-2xl border border-white/[0.07] bg-[rgba(13,18,32,0.7)] backdrop-blur-xl overflow-hidden">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 divide-y md:divide-y-0 md:divide-x divide-white/[0.05]">
            {ITEMS.map((it, i) => {
              const Icon = ICONS[it.icon];
              return (
                <div
                  key={it.title}
                  className="group px-5 lg:px-6 py-7 hover:bg-sapphire/[0.05] transition-colors duration-300"
                  data-testid={`capability-${i}`}
                >
                  <div className="w-9 h-9 rounded-lg border border-sapphire-glow/30 bg-sapphire/[0.10] inline-flex items-center justify-center group-hover:border-sapphire-glow/60 transition-colors">
                    <Icon className="w-4 h-4 text-sapphire-glow" />
                  </div>
                  <div className="mt-4 text-[14px] font-medium text-platinum tracking-tight leading-tight">
                    {it.title}
                  </div>
                  <div className="mt-2 text-[11.5px] text-platinum/55 leading-[1.55]">
                    {it.desc}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
